import { render } from "./UiCheckbox.vue?vue&type=template&id=b091ca7a&scoped=true"
import script from "./UiCheckbox.vue?vue&type=script&lang=js"
export * from "./UiCheckbox.vue?vue&type=script&lang=js"

import "./UiCheckbox.vue?vue&type=style&index=0&id=b091ca7a&lang=scss"
import "./UiCheckbox.vue?vue&type=style&index=1&id=b091ca7a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b091ca7a"]])

export default __exports__